import services from "@/composable/services";
import { TagMap } from "@/services/TagService";
import { LocalTag, type GenericTag } from "@/types/front/LocalTag";
import { StandardDataDescription } from "@/types/generated/UsedGeneratedTypes";

// Génère le set complet des tags d'un tableau de référence ou de données, indexé par tagName.
export function buildTags(
  refsOrDatas: { tags: LocalTag[] }[],
): Record<string, LocalTag> {
  const tagsArr: LocalTag[]
    = (refsOrDatas || [])
      .map(r => r.tags && r.tags.length > 0 ? r.tags : [new LocalTag()])
      .reduce<LocalTag[]>((acc, tagList) => {
        tagList.forEach((tag) => {
          if (
            (!acc.includes(tag) && tag.tagDefinition === "DOMAIN_TAG")
            || tag.tagDefinition === "NO_TAG"
          ) {
            acc.push(tag);
          }
        });
        return acc;
      }, []);
  if (tagsArr.length > 0) {
    const tagsArrAsMap: TagMap = {};
    tagsArr.forEach(t => tagsArrAsMap[t.tagName] = t);
    services.tagService.sizeCollapseTags(tagsArrAsMap);
  }
  return tagsArr.reduce<Record<string, LocalTag>>((acc, tag) => {
    acc[tag.tagName] = tag;
    return acc;
  }, {});
}

// Génère le set des tags présents sur des colonnes (filtrés), indexé par nom/tagName.
export function buildTagsColumns(
  columns: Record<string, StandardDataDescription>,
  tagsColumn: TagMap,
): TagMap {
  const tags: TagMap = {};
  for (const column in columns) {
    if (columns[column]) {
      const currentTags = columns[column].tags;
      currentTags
        .filter(
          tag =>
            tag.tagDefinition === "DOMAIN_TAG" || tag.tagDefinition === "NO_TAG",
        )
        .forEach((tag) => {
          let realTag: LocalTag;
          if (tag.tagName === LocalTag.NO_TAG_NAME) {
            realTag = new LocalTag();
          }
          else {
            realTag = new LocalTag(tag as GenericTag);
          }
          const tagKey = realTag.tagName ?? LocalTag.NO_TAG_NAME;
          if (!tags[tagKey]) {
            tags[tagKey] = realTag;
          }
        });
    }
  }
  if (Object.keys(tags).length > 0) {
    services.tagService.sizeCollapseTags(tagsColumn);
  }
  else {
    tags[LocalTag.NO_TAG_NAME] = new LocalTag();
  }
  return tags;
}
